import React from 'react'
import { PROJECT_ASSET_PHASE_OPTIONS } from '../../utils/projectAssetPhases'

export default function ProjectAssetPhaseSelect({
  value,
  onChange,
  onBlur,
  name = 'phase',
  label = 'Phase',
  topMargin = 'mt-4',
}) {
  return (
    <div className={topMargin}>
      <label className="block mb-2 text-sm font-regular dark:text-white">{label}</label>
      <select
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className="w-full p-2 border border-rb-lite-grey dark:border-rb-dark-mode-lighter dark:bg-rb-dark-mode dark:text-white rounded-lg focus:border-rb-green focus:outline-none"
      >
        {PROJECT_ASSET_PHASE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
